<template>
    <div class="wrapper">
        <TopBar></TopBar>
        <SideBar></SideBar>
        <div class="content-wrapper"
             v-bind:style="{ 'background-color': backgroundColor }">
            <section class="content-header">
                <div class="row">
                    <div class="col-md-8">
                        <h3>
                            {{ pageTitle }}
                        </h3>
                    </div>
                    <div class="col-md-4 text-right" v-if="createButton.display">
                        <h1>
                            <router-link :to="createButton.to" class="btn btn-primary" v-if="$accessControl.isOperator($store.state.profile.profile)">
                                {{ createButton.text }}
                            </router-link>
                        </h1>
                    </div>
                </div>
            </section>

            <transition name="fade" mode="out-in" v-on:after-enter="afterEnter" appear>
                <router-view :key="$route.path" v-on:addBackgroundColor="addBackgroundColor"></router-view>
            </transition>

        </div>

        <Foot></Foot>
    </div>
</template>

<script>
  import TopBar from './TopBar.vue'
  import SideBar from './SideBar.vue'
  import Foot from './Foot.vue'

  export default {
    name: 'baseComponent',

    computed: {
      pageTitle () {
        return this.$store.state.ui.pageTitle
      },
      createButton () {
        return this.$store.state.ui.createButton
      }
    },

    beforeCreate () {
      this.$store.dispatch('fillProfile')
    },

    beforeRouteEnter (to, from, next) {
      if (to.name !== 'login' || to.name !== 'logout') {
        if (sessionStorage.getItem('isLogged')) {
          next()
          return
        }
        next('/login')
      }
    },

    data () {
      return {
        backgroundColor: ''
      }
    },

    mounted () {
      $('body')
        .removeClass('login-page')
        .addClass('skin-blue sidebar-mini sidebar-collapse')
    },

    methods: {
      afterEnter: function (el) {
      },
      addBackgroundColor: function (backgroundColor) {
        this.backgroundColor = backgroundColor
      }
    },

    components: {
      TopBar,
      SideBar,
      Foot
    }
  }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.1s
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/BaseComponent.vue